import { useTranslation } from 'react-i18next';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { SmartTableCellProps } from '@/components/ui/daisy';
import { LessonBlockRef } from '@/models/ScheduledLesson';

type UnitCellItem = {
  lessonBlock: Pick<LessonBlockRef, 'order'> | null;
};

export default function UnitCell({ item }: SmartTableCellProps<UnitCellItem>) {
  const { t } = useTranslation('translation', { keyPrefix: 'pendencies' });
  const { lessonBlock } = item;

  return (
    <ConditionalRenderer condition={!!lessonBlock}>
      {t('unitName', { order: lessonBlock?.order })}
    </ConditionalRenderer>
  );
}
